import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';

import { Router } from '@angular/router';

import { MainService } from '../main.service';
import { Message } from 'primeng/primeng';

@Component({
  selector: 'app-new-release-bundle',
  templateUrl: './new-release-bundle.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['../../style.scss',
    './new-release-bundle.component.css']
})
export class NewReleaseBundleComponent implements OnInit {
  responce: any;
  msgs: Message[];
  projectList: any[];
  projectOptions: {};
  bundleOptions: {};
  selectedProject: any;
  bundleName: any;
  bundleDesc: any;
  releaseBundleForm: FormGroup;
  selectedDate;
  formatDate;
  month;
  selectedQA;
  userOptions: {};
  userList: any[];
  clickedOnce: boolean;


  userEmail = localStorage.getItem('userEmail');
  userName = localStorage.getItem('userName');

  constructor(private fb: FormBuilder, private mainService: MainService, private router: Router) { }

  createBundle() {

    this.clickedOnce = true;
    if (this.releaseBundleForm.valid) {

      this.bundleName = this.releaseBundleForm.get('bundle').value;
      this.selectedProject = this.releaseBundleForm.get('project').value;
      this.bundleDesc = this.releaseBundleForm.get('desc').value;
      this.selectedDate = this.releaseBundleForm.get('uatDate').value;
      this.selectedQA = this.releaseBundleForm.get('qa').value;

      this.month = this.selectedDate.getMonth() + 1;
      this.formatDate = this.selectedDate.getDate() + '/' + this.month + '/' + this.selectedDate.getFullYear()

      if (this.selectedProject != undefined) {
        if (this.bundleName != undefined && this.bundleName != '') {

          this.bundleOptions = {
            name: this.bundleName,
            desc: this.bundleDesc ? this.bundleDesc : this.bundleName,
            project: this.selectedProject.id,
            uatDate: this.formatDate,
            created_by: this.userName,
            qa: this.selectedQA.name

          };

          this.mainService.sendReleaseBundle(this.bundleOptions).then(rb => {
            this.responce = rb;
            if (this.responce != undefined) {
              this.msgs = [];
              this.msgs.push({ severity: 'success', summary: 'Release Bundle Added' });

              this.clickedOnce = true;

              setTimeout(() => {
                this.router.navigate(['/rb']);
              },
                1000);

            } else {
              this.clickedOnce = false;
            }
          });
        } else {
          this.msgs = [];
          this.msgs.push({ severity: 'warn', summary: 'Please Enter a Bundle Name' });
        }

      } else {
        this.msgs = [];
        this.msgs.push({ severity: 'warn', summary: 'Please Select a Project' });
      }
    } else {
      this.validateAllFormFields(this.releaseBundleForm);
      this.msgs = [];
      this.msgs.push({ severity: 'error', summary: 'Form is not Complete', detail: 'Please Check the Entered Data' });
    }

  }

  getUsers() {
    this.mainService.getUsers(this.userOptions).then(users => {
      this.userList = users;
    });

  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  ngOnInit() {

    localStorage.removeItem('previousURL');

    this.releaseBundleForm = this.fb.group({
      project: ['', Validators.required],
      bundle: ['', Validators.required],
      desc: ['', Validators.required],
      uatDate: ['', Validators.required],
      qa: ['', Validators.required]
    });

    this.projectOptions = {
      user: this.userEmail
    };

    this.mainService.getProjectList(this.projectOptions).then(projects => {
      this.projectList = projects;
    });

    this.releaseBundleForm.get('project').valueChanges.subscribe(proj => {
      if (proj != undefined) {

        this.userOptions = {
          id: proj.id,
          role: '',
        };

        this.getUsers();

      }

    })


  }

}